/** @format */

import { TStore } from "../declarations/store";
import { History } from "history";

export const selectorReduxStore = (store: TStore): TStore => store;

//@ts-ignore
export const selectorHistory = (store: TStore): History => store.router ?? {};
